import { render, staticRenderFns } from "./onlineAppointmentsSettings.vue?vue&type=template&id=5aeb09a2&"
import script from "./onlineAppointmentsSettings.vue?vue&type=script&lang=js&"
export * from "./onlineAppointmentsSettings.vue?vue&type=script&lang=js&"
import style0 from "./onlineAppointmentsSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports